import './HeroAuth.css'
import { SwordIcon } from './SwordIcon'

const HeroAuth = ({ user, onAuthClick, onAccountClick }) => {
  return (
    <div className="hero__auth">
      {user ? (
        <button className="hero__user-btn" onClick={onAccountClick} title="View Account">
          <SwordIcon isLoggedIn={true} size={32} />
          <span className="hero__username">{user.nickname || user.username}</span>
        </button>
      ) : (
        <button className="hero__login-btn" onClick={onAuthClick} title="Login / Create Account">
          <SwordIcon isLoggedIn={false} size={32} />
          <span className="hero__login-text">Login / Register</span>
        </button>
      )}
    </div>
  )
}

export default HeroAuth
